/**
 * Stellt Helfermethoden für Positions- und Größenberechnungen bereit. 
 *
 * @class service_v3sGeometricsService
 * @memberOf v3sWbtPlayerApp:helper
 */

angular.module('v3sWbtPlayerApp').factory('v3sGeometricsService', function () {
    /**
     * Kalkuliert die benötigte Länge zwischen 2 gegebenen Punkt
     * @param {number} x1 - x koordinate des ersten punkts
     * @param {number} y1 - y koordinate des ersten punkts
     * @param {number} x2 - x koordinate des zweiten punkts
     * @param {number} y2 - y koordinate des zweiten punkts
     * returns {string} length - Errechnete Länge in px
     */
    function calculateLength(x1, y1, x2, y2) {
        return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
    }


    /**
     * Errechnet den Winkel zwischen zwei Punkten und gibt den entsprechenden Wert für CSS-Transform Eigenschaft zurück
     * @param {number} x1 - x koordinate des ersten punkts
     * @param {number} y1 - y koordinate des ersten punkts
     * @param {number} x2 - x koordinate des zweiten punkts
     * @param {number} y2 - y koordinate des zweiten punkts
     * returns {string} transform - Der Wert für CSS-Transform
     */
    function calculateTransform(x1, y1, x2, y2) {
        var angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI;
        var transform = 'rotate(' + angle + 'deg)';
        return transform;
    }

    function calculateAngle(x1, y1, x2, y2) {
        return Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI;
    }

    /**
     * Errechnet die Mittelpunkte des übergebenen Elements
     * @param {object} el - angular.element
     */
    function getCenterPoint(el) {
        return {
            top: parseInt(el.attr('v3s-top')) + parseInt(el.attr('v3s-height')) / 2,
            left: parseInt(el.attr('v3s-left')) + parseInt(el.attr('v3s-width')) / 2
        }
    }

    /**
     * Errechnet die Ankerpunkte für die Verbindungslinien
     * Die vertikale Ankerpunkte werden um 3px nach "innen" verschoben, horizontale um 3
     * @param {object} el - angular.element
     */
    function getAnchorPoints(el) {
        var top = {
            x : parseInt(el.attr('v3s-left')) + (parseInt(el.attr('v3s-width')) / 2),
            y : parseInt(el.attr('v3s-top')) + 3
        }
        var left = {
            x : parseInt(el.attr('v3s-left')) + 2,
            y : parseInt(el.attr('v3s-top')) + (parseInt(el.attr('v3s-height')) / 2)
        }
        var right = {
            x : (parseInt(el.attr('v3s-left')) + parseInt(el.attr('v3s-width'))) - 2,
            y : parseInt(el.attr('v3s-top')) + (parseInt(el.attr('v3s-height')) / 2)
        }
        var bottom = {
            x : parseInt(el.attr('v3s-left')) + (parseInt(el.attr('v3s-width')) / 2),
            y : (parseInt(el.attr('v3s-top')) + parseInt(el.attr('v3s-height'))) - 3
        }

        return {
            top : top,
            left : left,
            right : right,
            bottom : bottom
        }

    }


    /**
     * Findet die kürzeste Verbindung zwischen 2 Elementen
     * @param from - das start-element
     * @param to - das ziel-element
     */
    function findBestConnection(from, to) {
        var fromAnchorPoints = getAnchorPoints(from);
        var toAnchorPoints = getAnchorPoints(to);
        var shortestDistance = 1000;
        var bestConnection = null;
        angular.forEach(fromAnchorPoints, function (fap) {
            angular.forEach(toAnchorPoints, function (tap) {
                var newLength = calculateLength(fap.x, fap.y, tap.x, tap.y);
                if (newLength < shortestDistance) {
                    shortestDistance = newLength;
                    bestConnection = {
                        x1: fap.x,
                        y1: fap.y,
                        x2: tap.x,
                        y2: tap.y
                    }
                }
            })
        })

        return bestConnection
    }

    function getOffset(el) {
        var htmlEl = el[0];
        var rect = htmlEl.getBoundingClientRect();

        return {
            top: rect.top + document.body.scrollTop,
            left: rect.left + document.body.scrollLeft
        }
    }

    return {
        getCenterPoint: getCenterPoint,
        calculateTransform: calculateTransform,
        calculateAngle: calculateAngle,
        calculateLength : calculateLength,
        getAnchorPoints: getAnchorPoints,
        findBestConnection: findBestConnection,
        getOffset: getOffset
    }
});